const STYLES = {
  healthy: "border-emerald-500/40 bg-emerald-500/10 text-emerald-400",
  warning: "border-yellow-500/40 bg-yellow-500/10 text-yellow-400",
  error: "border-red-500/40 bg-red-500/10 text-red-400",
  not_imported: "border-zinc-700 bg-zinc-800/60 text-zinc-500",
};

const DOTS = {
  healthy: "bg-emerald-400",
  warning: "bg-yellow-400",
  error: "bg-red-400",
  not_imported: "bg-zinc-500",
};

const LABELS = {
  healthy: "Healthy",
  warning: "Warning",
  error: "Error",
  not_imported: "Not Imported",
};

export const HealthBadge = ({ status, testId }) => (
  <span
    data-testid={testId}
    className={`inline-flex items-center gap-1.5 rounded-full border px-3 py-1 font-mono text-[11px] uppercase tracking-wide ${
      STYLES[status] || STYLES.not_imported
    }`}
  >
    <span className={`h-1.5 w-1.5 rounded-full ${DOTS[status] || DOTS.not_imported}`} />
    {LABELS[status] || "Not Imported"}
  </span>
);
